import {
    IDetailField,
} from '../../types';

import {
    formatAmount,
} from 'helpers';

import {
    UPI_P2P_KEY,
} from 'entities/payment-methods/constants';

export function formatUpiUrl(detailFields: IDetailField[], amountKopecks: number): string | null {
    const upiNumber = detailFields.find((detailField) => detailField.key === UPI_P2P_KEY.UPI_NUMBER)?.value;
    const accountName = detailFields.find((detailField) => detailField.key === UPI_P2P_KEY.ACCOUNT_NAME)?.value;

    if (!upiNumber || !accountName) {
        return null;
    }

    return `upi://pay?pa=${upiNumber}&am=${formatAmount(amountKopecks)}&cu=INR&pn=${accountName}`;
}
